import i18nDepartment from './vi/i18nDepartment';
import i18nOrganization from './vi/i18nOrganization';
import i18nFileUpload from './vi/i18nFileUpload';
import i18nComment from './vi/i18nComment';
import i18nMain from './vi/i18nMain';
import i18nValidate from './vi/i18nValidate';
import i18nTable from './vi/i18nTable';
import i18nCommon from './vi/i18nCommon';
import i18nEnum from './vi/i18nEnum';
import i18nComponent from './vi/i18nComponent';
import i18nColumn from './vi/i18nColumn';
import i18nPages from './vi/i18nPages';
import i18nColumnTemplate from './vi/i18nColumnTemplate';
import i18nBaseForm from './vi/i18nBaseForm';
import i18nAccountingObject from './vi/dictionary/i18nAccountingObject';
import i18nStock from './vi/dictionary/i18nStock';
import i18nTaskList from './vi/i18nTaskList';
import i18nReport from './vi/i18nReport';
import i18nManual from './vi/i18nManual';
import i18nImport from './vi/i18nImport';
import i18nUserManager from './vi/i18nUserManager';
import i18nJobTitle from './vi/i18nJobTitle';
import i18nSurveyCustomer from './vi/i18nSurveyCustomer';

export default {
  vi: {
    i18nOrganization,
    i18nDepartment,
    i18nFileUpload,
    i18nComment,
    i18nMain,
    i18nValidate,
    i18nCommon,
    i18nComponent,
    i18nEnum,
    i18nColumn,
    i18nPages,
    i18nBaseForm,
    i18nColumnTemplate,
    i18nTable,
    i18nStock,
    i18nAccountingObject,
    i18nTaskList,
    i18nUserManager,
    i18nReport,
    i18nManual,
    i18nImport,
    i18nJobTitle,
    i18nSurveyCustomer
  }
};
